import { List, ListItem, Table, TableBody, TableCell as TableCellBase, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import * as React from 'react';
import { CompanyModel, RelationshipModel } from 'api';
import { useCollection } from '@type-r/react';

const TableCell = (props) =>
    <TableCellBase
        align="left"
        {...props}
    />

const PermissionsList = ({ permissions }) => {
    const allPermissions = []
        .concat(
            permissions["OrderManagement"],
            permissions["InvoiceManagement"],
            permissions["InvoiceManagementReconciliation"],
            permissions["CashflowForecasting"],
            permissions["RelationshipDashboard"],
            permissions["AllModules"])
        .filter(permission => permission);
    return (
        <List>
            { allPermissions.map(permission =>
                <ListItem key={permission}>{permission}</ListItem>
            )}
        </List>
    );
};

export const RelationshipUsers = ({ relationship }: {
    relationship: RelationshipModel
}) => {
    const companies = useCollection.of(CompanyModel);
    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>User name</TableCell>
                        <TableCell>Company</TableCell>
                        <TableCell>First name</TableCell>
                        <TableCell>Last name</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Permissions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { relationship && relationship.relationshipUsers && relationship.relationshipUsers.length ?
                        relationship.relationshipUsers.map(row => {
                            const company = companies.get(row.companyId);
                            const companyName = company ? company.shortname || company.name : row.companyId.toString();
                            return (
                                <TableRow key={row.cid}>
                                    <TableCell>{row.userName}</TableCell>
                                    <TableCell>{companyName}</TableCell>
                                    <TableCell>{row.firstName}</TableCell>
                                    <TableCell>{row.lastName}</TableCell>
                                    <TableCell>{row.role}</TableCell>
                                    <TableCell>
                                        <PermissionsList permissions={row.permissions} />
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    :
                        <TableRow>
                            <TableCell align="center" colSpan={6}>
                                <Typography variant="h4">
                                    No entries
                                </Typography>
                            </TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
};
